<template>
  <div class="single-radio flex-column">
    <div v-for="(option, index) in (test.options || [])" :key="index">
      <div class="flex-row single-list" @click="baseInputClicked(option, index)">
        <div class="option-letter" :class="{ actived: actived === index }">{{ indexes[index] }}</div>
        <div class="option-text">
          <div class="option-content" v-html="convertTestText(option.content)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const answerArr = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
};
export default {
  name: 'single-test',
  props: {
    subIndex: {
      type: Number,
      default: () => -1,
    },
    test: {
      type: Object,
      default: () => { },
    },
    testId: {
      type: Number,
      default: () => null,
    },
    choiceAnswer: {
      type: String,
      default: () => '',
    },
    tempResult: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      indexes: [],
      actived: null,
    };
  },

  created() {
    this.indexes = this.handleAscii(this.test.options || []);
  },

  mounted() {
    this.initData();
    if (this.tempResult) {
      const key = this.indexes.findIndex((item) => item === this.tempResult);
      if (key !== -1) {
        this.actived = key;
      }
    }
  },

  watch: {
    test(newValue) {
      this.indexes = this.handleAscii(newValue.options || []);
      this.initData();
    },

    testId() {
      this.setWatch();
      this.initData();
    },

    tempResult(newValue) {
      if (newValue) {
        const key = this.indexes.findIndex((item) => item === newValue);
        if (key !== -1) {
          this.actived = key;
        }
      }
    },
  },

  methods: {
    initData() {
      // 优先使用 tempResult，如果没有再使用 choiceAnswer
      const answer = this.tempResult || this.choiceAnswer;
      if (answer) {
        const key = this.indexes.findIndex((item) => item === answer);
        if (key !== -1) {
          this.actived = key;
        }
      }
    },
    baseInputClicked(option, index) {
      let res = {};
      const isRight = option.is_right ? true : false;
      const result = this.indexes[index];
      this.actived = index;
      Object.assign(res, { result, subIndex: this.subIndex, isRight });
      // 实时触发 selectChange 事件保存答案
      this.$emit('selectChange', result);
      this.$emit('change', res);
    },
    setWatch() {
      this.actived = null;
      this.initData();
    },
  },
};
</script>

<style scoped>
.single-radio {
  padding-top: 10px;
}

.single-list {
  justify-content: flex-start;
  margin-bottom: 10px;
}

.option-letter {
  margin-right: 10px;
  width: 33px;
  height: 33px;
  border: 1px solid #e4e4e4;
  border-radius: 50%;
  background-color: #fff;
  line-height: 33px;
  text-align: center;
  font-size: 15px;
  color: #333;
}

.option-text {
  display: flex;
  align-items: center;
  flex: 1;
  line-height: 22px;
  font-size: 17px;
  color: #000;
}

.actived {
  border: 1px solid #007aff;
  background: #007aff !important;
  color: #fff !important;
}

/* .option-content {
  display: flex;
} */
</style>
